import { QueryParamsModel } from '../../_base/crud';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Allergy } from '../_models/allergy.model';
import { AllergyActions, AllergyActionTypes } from '../_actions/allergy.actions';

export interface AllergiesState extends EntityState<Allergy> {
  entityId: number;
  loading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedContactRelationshipId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
}

export function selectAllergyId(allergy: Allergy): number {
  return allergy.id;
}
export const adapter: EntityAdapter<Allergy> = createEntityAdapter<Allergy>({
  selectId: selectAllergyId,
});

export const initialAllergiesState: AllergiesState = adapter.getInitialState({
  loading: false,
  actionsloading: false,
  totalCount: 0,
  entityId: undefined,
  lastCreatedContactRelationshipId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
});

export function AllergiesReducer(
  state = initialAllergiesState,
  action: AllergyActions,
): AllergiesState {
  switch (action.type) {
    case AllergyActionTypes.ThrowAllergyError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        loading: false,
      };
    }
    case AllergyActionTypes.AllergyUpdated:
      return adapter.updateOne(action.payload.allergy, state);
    case AllergyActionTypes.AllergyPageToggleLoading:
      return {
        ...state,
        loading: action.payload.isLoading,
        lastCreatedContactRelationshipId: undefined,
      };
    case AllergyActionTypes.AllergyPageRequested:
      return {
        ...state,
        totalCount: 0,
        loading: true,
        showInitWaitingMessage: true,
        entityId: action.payload.entityId,
        lastQuery: action.payload.page,
      };
    case AllergyActionTypes.AllergyPageLoaded:
      return adapter.addMany(action.payload.allergies, {
        ...initialAllergiesState,
        totalCount: action.payload.totalCount,
        loading: false,
        entityId: state.entityId,
        lastQuery: state.lastQuery,
        showInitWaitingMessage: false,
      });
    case AllergyActionTypes.AllergyOnServerCreated:
      return { ...state, loading: true };
    case AllergyActionTypes.ClearAllergyErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case AllergyActionTypes.AllergyCreated:
      return adapter.addOne(action.payload.allergy, {
        ...state,
        lastCreatedContactRelationshipId: action.payload.allergy.id,
      });
    case AllergyActionTypes.AllergyActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    default:
      return state;
  }
}
export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
